
import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Task } from "./useTaskCreateMutation";

type wbsRiskImportResponse = ResponseType<Task[]>;

function useWbsRiskImportMutation(projectId?: string) {
  const mutation = useMutation<
    AxiosResponseAndError<wbsRiskImportResponse>["response"],
    AxiosResponseAndError<wbsRiskImportResponse>["error"],
    FormData
  >({
    mutationFn: (data) =>
      ApiRequest.post<wbsRiskImportResponse>(
        `${requestURLs.wbsRisk}${projectId}`,
        data
      ),
  });

  return mutation;
}

export default useWbsRiskImportMutation;
